import React from "react";
import "./Photos.css";

export default function Photos(props) {
  let images = props.images;

  if (images) {
    return (
      <section className="Photos row d-flex justify-content-center my-2 mx-3 pb-3 shadow">
        {images.map(function (image, index) {
          return (
            <div className="col-3 p-1 mx-2 my-2" key={index}>
              <a href={image.src.original} target="_blank" rel="noreferrer">
                <img
                  src={image.src.landscape}
                  className="img-fluid rounded shadow"
                  alt={image.alt}
                />
              </a>
            </div>
          );
        })}
      </section>
    );
  } else {
    return null;
  }
}
